// extracted by mini-css-extract-plugin
module.exports = {"breakdownTableContainer":"BreakdownTable_breakdownTableContainer__2u5lG","breakdownTableContainerTotals":"BreakdownTable_breakdownTableContainerTotals__1bAoz"};